import React, { useState } from "react";
import { FAQ_DATA } from "../../data/FAQ";
import { HiChevronRight, HiChevronDown, HiQuestionMarkCircle } from "react-icons/hi";
import { Link } from "react-router-dom";

const HomeFAQItem = ({ item, index, isOpen, onToggle }) => {
  return (
    <div
      className={`rounded-2xl border transition-all duration-300 overflow-hidden ${
        isOpen
          ? "bg-gradient-to-br from-primary/5 to-primary-green/5 border-primary/30 shadow-lg shadow-primary/5"
          : "bg-white/80 backdrop-blur-sm border-white/20 hover:border-primary/20 hover:shadow-md"
      }`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between p-5 lg:p-6 text-left"
      >
        <div className="flex items-center gap-4">
          <span
            className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold transition-all duration-300 ${
              isOpen
                ? "bg-gradient-to-r from-primary to-primary-green text-white"
                : "bg-primary/10 text-primary"
            }`}
          >
            {String(index + 1).padStart(2, "0")}
          </span>
          <h4
            className={`text-base lg:text-lg font-semibold transition-colors duration-300 ${
              isOpen ? "text-primary" : "text-secondary"
            }`}
          >
            {item.title}
          </h4>
        </div>
        <div
          className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 ${
            isOpen
              ? "bg-primary text-white rotate-180"
              : "bg-gray-100 text-gray-500"
          }`}
        >
          <HiChevronDown size={18} />
        </div>
      </button>
      <div
        className={`overflow-hidden transition-all duration-500 ease-in-out ${
          isOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 lg:px-6 pb-5 lg:pb-6">
          <div className="pl-12">
            <p
              className="text-gray-600 leading-relaxed text-sm lg:text-base"
              dangerouslySetInnerHTML={{ __html: item.details }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const HomeFAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);
  const specialFAQs = FAQ_DATA.filter((item) => item.special);

  return (
    <div className="w-full flex flex-col">
      {/* Section Header */}
      <div className="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-12">
        <div className="flex flex-col">
          <div className="flex items-center gap-2 mb-3">
            <HiQuestionMarkCircle className="text-primary" size={20} />
            <span className="text-primary roboto-font text-sm font-medium uppercase tracking-wider">
              Need Help?
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl abel-font text-secondary">
            Frequently Asked Questions
          </h2>
        </div>
        <Link
          to="/FAQ"
          className="group hidden sm:flex items-center gap-2 px-6 py-3 rounded-xl bg-gradient-to-r from-primary/10 to-primary-green/10 hover:from-primary/20 hover:to-primary-green/20 border border-primary/20 transition-all duration-300"
        >
          <span className="text-primary font-medium">See all questions</span>
          <HiChevronRight
            className="text-primary group-hover:translate-x-1 transition-transform duration-300"
            size={20}
          />
        </Link>
      </div>

      {/* FAQ Grid */}
      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-4">
        {specialFAQs.map((item, index) => (
          <HomeFAQItem
            key={index}
            item={item}
            index={index}
            isOpen={openIndex === index}
            onToggle={() => setOpenIndex(openIndex === index ? -1 : index)}
          />
        ))}
      </div>

      {/* Mobile See All Link */}
      <Link
        to="/FAQ"
        className="group flex sm:hidden items-center justify-center gap-2 w-full mt-8 py-3 rounded-xl bg-primary/10 hover:bg-primary/20 border border-primary/20 transition-all duration-300"
      >
        <span className="text-primary font-medium">More FAQ</span>
        <HiChevronRight
          className="text-primary group-hover:translate-x-1 transition-transform duration-300"
          size={20}
        />
      </Link>
    </div>
  );
};

export default HomeFAQ;
